<template>
  <AppRadioGroup
    class="checklist-item__type"
    v-model="itemType"
    :checked-value="itemType"
    :options="radioOptions"
    name="task-type"
  />
</template>

<script>
// Utils
import { tasksType } from 'Utils/config/checklists'
// Components
import AppRadioGroup from 'Ui/AppRadioGroup'

export default {
  name: 'ChecklistItemsItemType',

  components: {
    AppRadioGroup,
  },

  props: {
    value: {
      type: String,
      default: 'client',
    },
  },

  data() {
    return {
      itemType: this.value,
      radioOptions: tasksType,
    }
  },

  updated() {
    this.$emit('input', this.itemType)
  },
}
</script>

<style scoped>
.checklist-item__type {
  margin: 5px 0 10px;
}

.checklist-item__type >>> label {
  padding: 0;
}
</style>
